import React, { useRef, useState } from 'react';
import { generateClassName, generateSelectField, generateTextField, handleObjectFieldChange } from './helpers';
import CustomButton from './CustomButton';

import './NewImageForm.css';

const NewImageForm = ({ onImageUpload, className = null }) => {
    const fileInputRef = useRef(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    const defaultValues = {
        imageLabel: '',
        localeCode: '',
    };

    const [imageFields, setImageFields] = useState(defaultValues);

    const localeOptions = [
        { value: '', label: 'None' },
        { value: 'es', label: 'Spanish' },
        { value: 'ca', label: 'Catalan' },
        { value: 'en', label: 'English' },
    ];

    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            onImageUpload(file, imageFields);
            setImageFields(defaultValues);
        }
    }

    return (
        // <div>
        <form onSubmit={handleSubmit} className={generateClassName("image-form", "", className)}>
            {generateTextField("Image label", imageFields.imageLabel, generateClassName("image-form", "-field", className), false, (e) => handleObjectFieldChange('imageLabel', e.target.value, setImageFields), { required: false })}
            {generateSelectField(localeOptions,
                {
                    label: 'Locale',
                    value: imageFields.localeCode,
                    onChange: (e) => handleObjectFieldChange('localeCode', e.target.value, setImageFields),
                    className: generateClassName("image-form", "-field", className),
                })}
            <CustomButton type="submit" label="Submit" />
            <input
                ref={fileInputRef}
                type="file"
                style={{ display: 'none' }}
                onChange={handleImageUpload}
            />
        </form>
        // </div>
    );
};

export default NewImageForm;